import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { 
    X_LARGE_TEXT_PX,
    BASE_TEXT_PX,
    FONT_FAMILY_DEMI,
    X_SMALL_TEXT_PX,
    SMALL_TEXT_PX,
    SECONDARY_FONT_COLOR,
    PRIMARY_FONT_COLOR,
    TERTIARY_FONT_COLOR
} from 'src/styles/fonts/MCFontConstants.js';
import { FONT_FAMILY_REGULAR } from '../../../../styles/fonts/MCFontConstants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${X_SMALL_TEXT_PX};
    padding: 10px 0 0 0;
    min-height: 170px;

    ${media.mobileDevice`
        width: 100%;
        min-width: 310px;
    `}
`;

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const FieldLabel = styled.div`
    color: ${SECONDARY_FONT_COLOR};
    font-size: ${X_SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    font-weight: 600;
    line-height: ${BASE_TEXT_PX};
`;

export const WarningContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 4px;
    padding: 2px 0;
`;

export const WarningIcon = styled.img`
    width: ${X_LARGE_TEXT_PX};
    height: ${X_LARGE_TEXT_PX};
    flex-shrink: 0;
`;

export const WarningText = styled.div`
    color: ${PRIMARY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    font-weight: 400;
    line-height: ${X_LARGE_TEXT_PX};
    padding-top: 2px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;    

    ${media.mobileDevice`
        justify-content: center;
        gap: 12px;
    `}
`;

export const SelectedTerritoryValue = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SelectedPlaceholder = styled.div`
    color: ${TERTIARY_FONT_COLOR};
`;
